import apiClient, { ApiResponse, PaginatedApiResponse } from '../api/client';

export interface CountySubscription {
  id: number;
  status: 'active' | 'suspended' | 'cancelled' | string;
  amount: number;
  service_name: string;
  billing_cycle: string | null;
  asset_name: string | null;
  customer_name: string;
  customer_email: string | null;
  next_payment_date: string | null;
  last_payment_date: string | null;
  payment_count: number;
  is_due_for_payment: boolean;
  is_overdue: boolean;
}

export interface SubscriptionFilters {
  search?: string;
  status?: string;
  page?: number;
  per_page?: number;
}

export type SubscriptionAction = 'cancel' | 'pause' | 'resume';

class SubscriptionService {
  private baseUrl = '/admin/county/subscriptions';

  async getSubscriptions(filters?: SubscriptionFilters): Promise<PaginatedApiResponse<CountySubscription>> {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', String(filters.page));
    if (filters?.per_page) params.append('per_page', String(filters.per_page));
    const qs = params.toString();
    // apiClient.get is typed as ApiResponse<T> (no meta); Laravel paginators return meta at the root,
    // so cast here rather than weaken the public signature.
    const res = await apiClient.get<CountySubscription[]>(`${this.baseUrl}${qs ? `?${qs}` : ''}`);
    return res as unknown as PaginatedApiResponse<CountySubscription>;
  }

  async updateStatus(id: number, action: SubscriptionAction): Promise<ApiResponse<CountySubscription>> {
    return apiClient.put(`${this.baseUrl}/${id}/status`, { action });
  }
}

export const subscriptionService = new SubscriptionService();
export default SubscriptionService;
